import { DrawnDog } from './DrawnDog'
import { Letter } from './Letter'

/**
 * The dog that carries the RSVP away.
 *
 * This file only chooses between the two ways of drawing him. The real artwork
 * and its moving parts are in DrawnDog.tsx, dogArt.ts and dogParts.ts.
 *
 * ---------------------------------------------------------------------------
 * Using a different picture
 * ---------------------------------------------------------------------------
 * DOG_IMAGE swaps the whole thing for a bitmap. Note that a bitmap cannot be
 * split up, so it loses the wagging and the legs - it is only worth it for a
 * still. To keep the animation with different artwork, replace the paths in
 * dogArt.ts and re-measure the regions in dogParts.ts instead.
 */
const DOG_IMAGE: string | null = null

/** Where the letter sits on DOG_IMAGE, as a percentage of width and height. */
const MOUTH_X = 10
const MOUTH_Y = 34

export interface DogProps {
  /**
   * When set, the letter is drawn in the dog's jaws with this class applied to
   * it. The class - not a boolean - is what controls whether it is visible, so
   * the hand-off can be timed in CSS alongside the run without the whole dog
   * fading in and out with it.
   */
  letterClassName?: string | undefined
  className?: string | undefined
}

export function Dog({ letterClassName, className }: DogProps) {
  if (DOG_IMAGE !== null) {
    return (
      <div className={`relative ${className ?? ''}`}>
        <img src={DOG_IMAGE} alt="" className="h-full w-full object-contain" />
        {letterClassName !== undefined && (
          <div
            className={`absolute ${letterClassName}`}
            style={{
              left: `${MOUTH_X}%`,
              top: `${MOUTH_Y}%`,
              width: '24%',
              transform: 'translate(-50%, -50%) rotate(-7deg)',
            }}
          >
            <Letter className="h-full w-full" />
          </div>
        )}
      </div>
    )
  }

  return <DrawnDog letterClassName={letterClassName} className={className} />
}
